
import { SearchContainer } from '../../dashboard/subContent/searchContainer/SearchContainer'
import useSearchMember from '../../../hooks/fetchUsers'
import { DeliveryDataTable } from './DeliveryDataTable'
import { deliveryStatesMapping } from './DeliverystateModel'
import { deliverySearchSchema } from './deliverySearchSchema'
// import { DeliveryActionsPack } from './deliveryActionMock'
import { useEffect } from 'react'
import { DeliveryActionsPack } from './DeliveryActionMock'
import { DeliveryService } from '../../../services/deliveryServices'

export const Delivery = () => {
  useEffect(() => {
    document.title = 'TPA® Admin - Envios '
  }, [])

  const URL = 'Delivery'

  const { renderUsers, handleObject, loading, customData } = useSearchMember(URL)



  useEffect(() => {


    const stateOptions = async () => {
      try {
        const states = await DeliveryService.getStates()

      } catch (error) {
        console.error(error);
        throw error;
      }
    }

    stateOptions()

  }, [])




  //? array de opciones de prueba

  const selectListOptions = [
    { id: 1, name: 'Pendiente/Retiro' },
    { id: 2, name: 'Enviado' },
    { id: 5, name: 'Cancelado' },
    { id: 7, name: 'Contactado' },
  ]

  return (
    <>

      <div className='m-4'>

        <div className='formation-card-header'>
          <div className='formation-container-actions card-tools'>

            <div className="title-decoration">
              <div class="accent-line"></div>
              <h1 className='pull-left formation-page-title mb-0'>Envíos</h1>
            </div>

          </div>
        </div>
      </div>

      <SearchContainer
        handleObject={handleObject}
        searchSchema={deliverySearchSchema}
        defaultParam={'Status'}
        paramDfValue={'Undefined'}
        // selectListOptions={[]}
        selectListOptions={selectListOptions}
      />


      <DeliveryDataTable
        stateModel={deliveryStatesMapping}
        currentPagination={customData.current}
        usersData={renderUsers}
        actionPack={DeliveryActionsPack}
        handleObject={handleObject}
        loading={loading}
        memberShip={true} //👉 activa el modal de informacion del miembro
        alert={true} //👉 activa el modal de alerta de acciones 
      // onFilter={handleObject}
      />
    </>
  )
}
